var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('modal', {
    staticClass: "dialer_animation right_side_popup m-w-600 scrollable bigSquareCheckbox IosModal",
    attrs: {
      "width": "50%",
      "scrollable": true,
      "height": "auto",
      "name": _vm.modalName
    },
    on: {
      "before-open": function ($event) {
        return _vm.onBeforeOpen($event);
      },
      "before-close": function ($event) {
        return _vm.onBeforeClose();
      }
    }
  }, [_vm.conditions.screen == _vm.screens.edit ? [_c('div', {
    staticClass: "d-flex align-items-center mb-3 calc-title-widthIOS v2"
  }, [_c('div', {
    staticClass: "settingsTextAndIconOnTop",
    on: {
      "click": function ($event) {
        _vm.conditions.screen = _vm.screens.view;
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "backToSettingsList-IOSIcon",
      "width": "11.434",
      "height": "20"
    }
  })], 1), _c('div', {
    staticClass: "dialer-settings-title topMainHeading"
  }, [_vm._v("Edit Team")]), _c('div', {
    staticClass: "plus-IOSIcon-container"
  })]), _c('div', {
    staticClass: "innerModalIos"
  }, [_c('div', {
    staticClass: "lg-mar-bottom"
  }, [_c('form', {
    staticClass: "dialer-form lg-mar-bottom",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        '';
      }
    }
  }, [_c('b-alert', {
    staticClass: "mt-32px",
    attrs: {
      "show": !!_vm.api.update_label.error_message,
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.api.update_label.error_message))]), _c('div', {
    staticClass: "basicWhiteIOScard mt-32px mb-16px"
  }, [_c('div', {
    staticClass: "basicWhiteIOScard-item"
  }, [_c('div', {
    staticClass: "mobileInputIOS InputIosV2"
  }, [_c('label', [_vm._v("Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.forms.update_label.name,
      expression: "forms.update_label.name"
    }],
    staticClass: "w-100",
    attrs: {
      "placeholder": "Enter Name",
      "type": "text",
      "disabled": _vm.api.update_label.send
    },
    domProps: {
      "value": _vm.forms.update_label.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.forms.update_label, "name", $event.target.value);
      }, _vm.updateLabel]
    }
  }), _vm.forms.update_label.submitted && _vm.$v.forms.update_label.name.$invalid || _vm.api.update_label.validation_errors.name ? _c('p', {
    staticClass: "text text-danger animated bounceIntop"
  }, [!_vm.$v.forms.update_label.name.required ? _c('span', [_vm._v("* Name is required")]) : _vm._e(), _vm._l(_vm.api.update_label.validation_errors.name, function (em) {
    return _c('span', {
      key: em
    }, [_vm._v("* " + _vm._s(em))]);
  })], 2) : _vm._e()])])])], 1)])])] : [_c('div', {
    staticClass: "d-flex align-items-center mb-3 calc-title-widthIOS v2"
  }, [_c('div', {
    staticClass: "settingsTextAndIconOnTop",
    on: {
      "click": function ($event) {
        return _vm.$modal.hide(_vm.modalName);
      }
    }
  }, [_c('vb-icon', {
    attrs: {
      "icon": "backToSettingsList-IOSIcon",
      "width": "11.434",
      "height": "20"
    }
  })], 1), _c('div', {
    staticClass: "dialer-settings-title topMainHeading"
  }, [_vm._v("Edit Team")]), _c('div', {
    staticClass: "plus-IOSIcon-container",
    on: {
      "click": function ($event) {
        _vm.conditions.screen = _vm.screens.edit;
      }
    }
  }, [_c('div', {
    staticClass: "textInsideCard onRightSide primaryColor"
  }, [_vm._v("Edit")])])]), _c('div', {
    staticClass: "innerModalIos"
  }, [_c('div', {
    staticClass: "lg-mar-bottom"
  }, [_c('div', {
    staticClass: "profile-image-section-container forIos mt-32px"
  }, [_c('div', {
    staticClass: "profile-image-section",
    on: {
      "click": function ($event) {
        return _vm.$modal.show('TeamProfileImageUploader', {
          type: 'TEAM',
          accountcode: _vm.team.real_id,
          current_image: _vm.teamImage
        });
      }
    }
  }, [_c('div', {
    staticClass: "profile-img"
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "user-profile-image-updated",
      "src": _vm.teamImage,
      "alt": _vm.team.name
    },
    on: {
      "error": function ($event) {
        $event.target.src = _vm.local_filess.images.user_male;
      }
    }
  })])])]), _c('div', {
    staticClass: "BiggestMainHeading mt-22px"
  }, [_vm._v(_vm._s(_vm.team.name))]), _c('div', {
    staticClass: "basicWhiteIOScard mt-32px mb-16px"
  }, [_c('div', {
    staticClass: "basicWhiteIOScard-item",
    on: {
      "click": function ($event) {
        return _vm.$modal.show('EditTeamAssignNumberModal', {
          accountcode: _vm.accountcode
        });
      }
    }
  }, [_c('div', {
    staticClass: "headingInsideTable"
  }, [_vm._v("Team Numbers")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "textInsideCard textAlignRight onRightSide mr-6px"
  }, [_vm._v(_vm._s(_vm.dids.length))]), _c('vb-icon', {
    staticClass: "rightFacingArrow",
    attrs: {
      "icon": "rightFacingArrow-IOSIcon",
      "width": "7.066",
      "height": "11.57"
    }
  })], 1)]), _c('div', {
    staticClass: "basicWhiteIOScard-item",
    on: {
      "click": function ($event) {
        return _vm.$modal.show('AssignMembersTeam', {
          real_id: _vm.data.real_id
        });
      }
    }
  }, [_c('div', {
    staticClass: "headingInsideTable"
  }, [_vm._v("Team Members")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "textInsideCard textAlignRight onRightSide mr-6px"
  }, [_vm._v(_vm._s(_vm._f("get_property")(_vm.team, 'members.length', 0)))]), _c('vb-icon', {
    staticClass: "rightFacingArrow",
    attrs: {
      "icon": "rightFacingArrow-IOSIcon",
      "width": "7.066",
      "height": "11.57"
    }
  })], 1)])]), _c('div', {
    staticClass: "basicWhiteIOScard mt-32px mb-16px"
  }, [_c('div', {
    staticClass: "basicWhiteIOScard-item"
  }, [_c('div', {
    staticClass: "headingInsideCard"
  }, [_vm._v("Pickup Groups")]), _c('div', {
    staticClass: "position-relative"
  }, [_c('b-form-checkbox', {
    ref: "pickup_groups",
    staticClass: "dialer-switch IosSwitch",
    attrs: {
      "name": "check-button",
      "switch": "",
      "disabled": !_vm.getUserPermissions.call_pickup || _vm.api.delete_team.send || _vm.api.update_pickgroup.send,
      "checked": _vm.conditions.pickup_droup
    },
    on: {
      "change": function ($event) {
        return _vm.updatePickupGroup($event);
      }
    }
  })], 1)]), _c('OutOfHourWidget', {
    staticClass: "withBottomBorder",
    attrs: {
      "accountcode": _vm.accountcode
    }
  }), _c('CallForwardingWidget', {
    staticClass: "withBottomBorder",
    attrs: {
      "accountcode": _vm.accountcode
    }
  }), _c('MusicOnHoldWidget', {
    attrs: {
      "accountcode": _vm.accountcode
    }
  })], 1)])])], _c('ProfileImageUploaderModal', {
    attrs: {
      "modalName": 'TeamProfileImageUploader'
    },
    on: {
      "image-uploaded": function ($event) {
        return _vm.$emit('updated');
      }
    }
  }), _c('AssignNumbersModal', {
    attrs: {
      "modalName": 'EditTeamAssignNumberModal'
    },
    on: {
      "added": function ($event) {
        return _vm.$emit('updated');
      }
    }
  }), _c('AddRemoveUsersModal', {
    attrs: {
      "modalName": 'AssignMembersTeam',
      "type": 'assign_team'
    },
    on: {
      "update-list": function ($event) {
        return _vm.$emit('updated');
      }
    }
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }